import { cacheConfig, http } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';
import { LocationQuery } from 'vue-router';

export default class SubmissionService {
   async postSubmissionNotification(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission-notification', body).then((response) => {
         if (response.status == 200) {
            return response.data;
         } else {
            throw new Error();
         }
      });
   }
   async postFakeRemindEmail(language: String, journeyId: Number) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/fake-notification/' + journeyId + '/remind', {
            params: { language: language },
         })
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error();
            }
         })
         .catch((error) => {
            throw Error();
         });
   }
   async postFakeEndEmail(language: String, journeyId: Number, type: String) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/fake-notification/' + journeyId + '/end', {
            params: { language: language, type },
         })
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error();
            }
         })
         .catch((error) => {
            throw Error();
         });
   }
   async getSubmissionStates() {
      return http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission-state/', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
   async patchSubmissionById(patch: any) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission/' + patch.id, patch.body, {
            params: {
               include:
                  'referrals,candidate_steps.answers.choice.tag,tags,addresses.city,entry_referral.journey_team.team.tenant,redirected_referral.journey_team.team.tenant,submission_comment,candidate_steps.step',
            },
         })
         .then((response) => {
            return response.data;
         });
   }
   async getSubmissions(query: LocationQuery) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + `/submission`, {
            params: {
               ...query,
               include:
                  'referrals,candidate_steps.answers.choice.tag,tags,addresses.city,entry_referral.journey_team.team.tenant,redirected_referral.journey_team.team.tenant,submission_comment',
            },
         })
         .then((response) => {
            return response.data;
         });
   }
   async getSubmissionById(id: Number, cancelToken?: CancelToken) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission/' + id, {
            cancelToken: cancelToken,
            params: {
               include:
                  'referrals,candidate_steps.answers.choice.tag,tags,addresses.city,entry_referral.journey_team.team.tenant,redirected_referral.journey_team.team.tenant,submission_comment,candidate_steps.step,candidate_steps.answers.media',
            },
         })
         .then((response) => {
            return response.data;
         });
   }
   async getSubmissionHistory(id: Number) {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission/' + id + '/history').then((response) => {
         return response.data;
      });
   }
   async deleteSubmission(id: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission/' + id)
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error(`Inzending kon niet verwijderd worden`);
            }
         })
         .catch((error) => {
            throw Error(`Inzending kon niet verwijderd worden`);
         });
   }

   async forceDeleteSubmission(id: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission/' + id + '/force')
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error(`Inzending kon niet geforceerd verwijderd worden`);
            }
         })
         .catch((error) => {
            throw Error(`Inzending kon niet geforceerd verwijderd worden`);
         });
   }

   async postSubmissionOccurence(submissionId: Number, comment: String) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/submission-occurrence', {
            submission_id: submissionId,
            comment: comment,
         })
         .then((response) => {
            return response.data;
         });
   }

   async getTagsByReferralId(submissionIds: Array<String | Number>) {
      return await http
         .get(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/submission/tags-by-referral-id?submission_ids=${submissionIds.join(',')}`)
         .then((response) => response.data);
   }

   async sendToNxtPlan(submissionId: Number | String) {
      return await http
         .post(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/submission/${submissionId}/send-to-nxt-plan`)
         .then((response) => response.data);
   }

   async sendToNxtPlanInBulk(body: any) {
      return await http.post(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/submission/bulk/send-to-nxt-plan`, body).catch((error) => {
         return Promise.reject(error);
      });
   }

   async fetchAllowedOrNot(body: any) {
      return await http.get(`/submission/allowed-or-not`, { params: body }).then((response) => response.data);
   }

   async findPeople(submissionId: Number | String) {
      return await http
         .post(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/submission/${submissionId}/find-candidates`, null, {
            params: { include: 'all' },
         })
         .then((response) => response.data);
   }

   async getNxtCandidateSubmission(candidate_sync_id: String) {
      return await http
         .get(`${import.meta.env.VITE_APP_API_BASE_URL_DATA}/nxt-candidates/${candidate_sync_id}/submissions`, {
            params: { include: 'journey,status,journeyReferral,modules' },
         })
         .then((response) => response.data);
   }

   async exportSubmissions({ submission_ids, language_key }: { submission_ids: Array<Number | String>; language_key: String }) {
      return await http
         .post(
            `${import.meta.env.VITE_APP_API_BASE_URL_DATA}/submission/bulk/export-pdf`,
            {
               submission_ids,
               language_key,
            },
            {
               responseType: 'arraybuffer',
            }
         )
         .then((response) => {
            return response.data;
         });
   }
}
